import { GdprStorageType } from "UidispatcherApiModule";
const { GdprStorage }: { GdprStorage: GdprStorageType } =
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export { GdprStorage };
